class ROICalculator extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('#RoiCalculate');

    this.salaryIncrease = this.querySelector('#salary-increase');
    this.yearsTeaching = this.querySelector('#years-teaching');
    this.pensionPercentage = this.querySelector('#pension-percentage');
    this.costAdvancement = this.querySelector('#cost-advancement');

    this.lifetimeAmount = this.querySelector('#lifetime-amount');
    this.costScale = this.querySelector('#cost-scale');
    this.roi = this.querySelector('#roi');

    this.button.addEventListener('click', this.calculateROI.bind(this));
  }

  calculateROI() {
    let error = false;

    const annualIncreaseInput = this.salaryIncrease.value;
    const yearsTeachingInput = this.yearsTeaching.value;
    const pensionPercentageInput = this.pensionPercentage.value;
    const costAdvancementInput = this.costAdvancement.value;

    if (!annualIncreaseInput) {
      error = true;
      this.salaryIncrease.classList.add('error');
    } else {
      this.salaryIncrease.classList.remove('error');
    }

    if (!yearsTeachingInput) {
      error = true;
      this.yearsTeaching.classList.add('error');
    } else {
      this.yearsTeaching.classList.remove('error');
    }

    if (!pensionPercentageInput) {
      error = true;
      this.pensionPercentage.classList.add('error');
    } else {
      this.pensionPercentage.classList.remove('error');
    }

    if (!costAdvancementInput) {
      error = true;
      this.costAdvancement.classList.add('error');
    } else {
      this.costAdvancement.classList.remove('error');
    }

    if (error) {
      this.lifetimeAmount.value = '';
      this.costScale.value = '';
      this.roi.value = '';

      return;
    }

    const annualIncrease = parseFloat(annualIncreaseInput);
    const yearsTeaching = parseFloat(yearsTeachingInput);
    const pensionPercentage = parseFloat(pensionPercentageInput);
    const costAdvancement = parseFloat(costAdvancementInput);

    const X = annualIncrease * yearsTeaching;
    const Y = (pensionPercentage / 100) * annualIncrease * 12.2;

    const totalEarnings = X + Y;
    const roi = totalEarnings - costAdvancement;

    this.lifetimeAmount.value = totalEarnings.toFixed(2);
    this.costScale.value = costAdvancement.toFixed(2);
    this.roi.value = roi.toFixed(2);
  }
}

customElements.define('roi-calculator', ROICalculator);
